/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  FormGroup,
  Modal,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import "moment-duration-format";

// actions
import {
  resetPredefinedMessages,
  resetError,
  getPredefinedMessages,
  deletePredefinedMessage,
} from "../../store/predefinedmessages/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

import BadgesEllipsis from "../../components/Common/BadgesEllipsis";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { renderPagination } from "../../Libs/CrudUtils/crudUtils";

const PredefinedMessages = ({ t }) => {
  const dispatch = useDispatch();

  const qtdDefault = 7;

  const {
    dataPredefinedMessage,
    dataPredefinedMessageDelete,
    loadingPredefinedMessage,
    loadingPredefinedMessageDelete,
    errorPredefinedMessage,
    successPredefinedMessage,
  } = useSelector((state) => state.PredefinedMessage);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [predefinedMessageId, setPredefinedMessageId] = useState("");
  const [predefinedMessageName, setPredefinedMessageName] = useState("");
  const [nameFilter, setNameFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successPredefinedMessage &&
      dispatch(resetPredefinedMessages()) &&
      handleFilter(),
  };

  const handleFilter = (name) => {
    setNameFilter(name);
    setPage(1);
    dispatch(getPredefinedMessages(1, qtdDefault, name));
  };

  const handleDelete = () => {
    dispatch(deletePredefinedMessage(predefinedMessageId));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setPredefinedMessageIdName = (predefinedMessage) => {
    setPredefinedMessageId(predefinedMessage.id);
    setPredefinedMessageName(predefinedMessage.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getPredefinedMessages(value, qtdDefault, nameFilter));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataPredefinedMessage && dataPredefinedMessage.paging) {
      if (page < dataPredefinedMessage.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  useEffect(() => {
    if (dataPredefinedMessageDelete && dataPredefinedMessageDelete.message) {
      showToast("success", t(dataPredefinedMessageDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successPredefinedMessage]);

  useEffect(() => {
    if (errorPredefinedMessage && typeof errorPredefinedMessage === "object") {
      errorPredefinedMessage.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "Predefined message not found" &&
          showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorPredefinedMessage) {
        showToast("error", t(errorPredefinedMessage));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorPredefinedMessage]);

  useEffect(() => {
    if (dataPredefinedMessage !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataPredefinedMessage]);

  useEffect(() => {
    handleFilter();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/predefinedMessages"
            title={t("Dashboard")}
            breadcrumbItem={t("Predefined Messages")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="card-height">
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="4" lg="3" xl="auto" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Title")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Title") + "..."}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div
                          className="text-sm-right mb-3"
                          id="new-predefined-message"
                        >
                          <Link to={`/predefined-message`}>
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Predefined Message")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>
                              <span className="ml-2">{"#"}</span>
                            </th>
                            <th>{t("Title")}</th>
                            <th>{t("Text")}</th>
                            <th>{t("Skills")}</th>
                            <th>{t("Categories")}</th>
                            <th>{t("Global")}</th>
                            <th>{t("Activated")}</th>
                            <th className="text-right pr-4">{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingPredefinedMessage ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataPredefinedMessage &&
                            dataPredefinedMessage.predefined_message &&
                            dataPredefinedMessage.predefined_message.length >
                              0 ? (
                            dataPredefinedMessage.predefined_message.map(
                              (predefinedMessage, key) => (
                                <tr key={key}>
                                  <td className="pl-4">{key + 1}</td>
                                  <td className="column-text-overflow-25">
                                    {predefinedMessage.title}
                                  </td>
                                  <td className="column-text-overflow-25">
                                    {predefinedMessage.text}
                                  </td>
                                  <td>
                                    {Array.isArray(predefinedMessage.skills) &&
                                    predefinedMessage.skills.length > 0 ? (
                                      <BadgesEllipsis
                                        objItems={predefinedMessage.skills}
                                      />
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    {Array.isArray(predefinedMessage.categories) &&
                                    predefinedMessage?.categories.length>0 ? (
                                      <BadgesEllipsis
                                      objItems={predefinedMessage.categories.map((e, key)=>({id: key, name: e}))}
                                      />
                                    ) : (
                                      "-"
                                    )
                                  } 
                                  </td>
                                  <td className="text-center">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        checked={predefinedMessage.global}
                                        readOnly
                                      />
                                      <label className="custom-control-label"></label>
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        checked={predefinedMessage.activated}
                                        readOnly
                                      />
                                      <label className="custom-control-label"></label>
                                    </div>
                                  </td>
                                  <td className="text-right">
                                    <Link
                                      to={`/predefined-message/${predefinedMessage.id}`}
                                      className="text-primary text-center"
                                      id="edit"
                                    >
                                      <i
                                        className="mdi mdi-pencil font-size-18 px-2"
                                        id={`edittooltip${key}`}
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target={`edittooltip${key}`}
                                      >
                                        {t("Edit")}
                                      </UncontrolledTooltip>
                                    </Link>
                                    {/* TODO: add custom styles to css file */}
                                    <span className="pointer">
                                      <i
                                        className="mdi mdi-window-close text-danger font-size-18 px-2"
                                        id={`deletetooltip${key}`}
                                        onClick={() => {
                                          toggleModal();
                                          setPredefinedMessageIdName(
                                            predefinedMessage
                                          );
                                        }}
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target={`deletetooltip${key}`}
                                      >
                                        {t("Delete")}
                                      </UncontrolledTooltip>
                                    </span>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal || loadingPredefinedMessageDelete}>
                        <div className="modal-body font-size-18 text-center">
                          {t("Do you want to delete the predefined message")}
                          <strong> {predefinedMessageName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingPredefinedMessageDelete ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (predefinedMessageId) handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>
                  {renderPagination(
                    page,
                    dataPredefinedMessage?.paging,
                    handlePreviousPage,
                    handlePage,
                    handleNextPage
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(PredefinedMessages);
